import React, { useState } from "react"
import Navbar from "../../components/player/Navbar.tsx";
import SportsSchedule from "../../components/player/SportsSchedule.tsx";
import Footer from "../../components/player/Footer.jsx";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "../../components/player/navigation.jsx";
import TeaserMenu from "../../components/player/TeaserMenu.tsx";
import { usePlayerChrome } from "../../hooks/usePlayerChrome.ts";

/**
 * Represents the home page of the application.
 * It includes a navigation bar, a navigation section, sports schedule, and a schedule table.
 * @returns JSX elements representing the home page layout.
 */
const Layout = () => {
    usePlayerChrome();
    const location = useLocation();
    const [showFooter, setShowFooter] = useState(true);
    const showSportsSchedule = location.pathname === "/home" || location.pathname === "/home/parlay";
    const showTeaserMenu = location.pathname === "/home/teaser";
    const isPropsPage = location.pathname.includes("/props");

    return (
        <div className="player-layout">
            <Navbar setShowFooter={setShowFooter} />
            <main className={isPropsPage ? "grow" : "custom-container grow"} style={{ flex: "1 0 auto", width: "100%" }} >
                {!isPropsPage && (
                    <div className="row">
                        <div className="col-12">
                            <Navigation />
                        </div>
                    </div>
                )}
                <div className="row">
                    {(showSportsSchedule || showTeaserMenu) && (
                        <div className="col-lg-3 col-xs-12">
                            {showSportsSchedule && <SportsSchedule setShowFooter={setShowFooter} />}
                            {showTeaserMenu && <TeaserMenu setShowFooter={setShowFooter} />}
                        </div>
                    )}
                    <div className={(showSportsSchedule || showTeaserMenu) ? "col-lg-9 col-xs-12" : ""}>
                        <Outlet />
                    </div>
                </div>
            </main>
            {showFooter && <Footer />}
        </div>
    );
}
export default Layout;
